// Checkbox.js
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Pressable, Text, View } from "react-native";
import { Feather } from "@react-native-vector-icons/feather";  // https://feathericons.com/?query=

const Checkbox = React.forwardRef((props, ref) => {
  const defaultValue = (!!props.value || (!!props.checked || false));
  const containerStyle = {flexDirection:"row",justifyContent:"flex-start",alignItems:"center",...(!!props.containerStyle ? props.containerStyle : {})};
  const ifDisabledStypeStyle = (!!props.disabled && window.main.platform_os === "web" ? {cursor:"default"} : {});
  const onChangeCallback = (props.onChange || null);
  const linkedFormRef = (props.linkedFormRef || null);
  const linkedRefIds = (!!linkedFormRef && Array.isArray(props.linkedRefIds) ? props.linkedRefIds : []);
  const [isChecked, _setIsChecked] = useState(defaultValue);
  if (!ref || !("current" in ref)) {
    ref = useRef();
  }

  // Initializer
  useEffect(()=>{
    // Attach the proxy Setter method for accessibility so it's the same in both web and mobile. Getter is just plain .checked
    ref.current.setChecked = setIsChecked;      // USE: `ref.current.setChecked(true/false)`
    ref.current.toggleChecked = toggleChecked;  // USE: `ref.current.toggleChecked()`
    ref.current.checked = defaultValue;         // USE: `ref.current.checked`
    // Apply the default value
    _setIsChecked(defaultValue);
  },[defaultValue]);

  // Proxy Setter
  const setIsChecked = useCallback((newIsChecked) => {
    // This sets the accessable `.current.checked` as well as the `state` so they stay in sync.
    ref.current.checked = newIsChecked;
    _setIsChecked(newIsChecked);
    if (!!linkedFormRef && !!linkedRefIds.length && !!newIsChecked) {
      // Un-check any other linked checkboxes
      linkedRefIds.forEach(_linkedRefId => {
        let _linkedRef = linkedFormRef.getRef(_linkedRefId);
        if (!!_linkedRef.current?.checked && !!_linkedRef.current.checked && !!_linkedRef.current?.setChecked) {
          _linkedRef.current.setChecked(false);
        }
      });
    }
    if (typeof(onChangeCallback)==="function") {
      onChangeCallback(newIsChecked);
    }
  },[ref,linkedFormRef,linkedRefIds,isChecked]);

  // Proxy Toggler
  const toggleChecked = useCallback(() => {
    if (!!props.disabled) {
      return false;
    }
    setIsChecked(!ref.current.checked);
  },[props,ref,isChecked]);

  let iconColor = (!!props.disabled ? window.main.theme.colors.monoDark : (!!isChecked ? (props.checkedColor || window.main.theme.colors.base) : (props.uncheckedColor || window.main.theme.colors.monoDark)));

  // Return Component
  return (
    <Pressable ref={ref} id={props.nativeID} style={{paddingHorizontal: 6, paddingVertical: 6, width: 26, ...containerStyle, ...ifDisabledStypeStyle}} onPress={toggleChecked} activeOpacity={0.7}>
      <Feather name={(!!isChecked ? "check-square" : "square")} size={16} color={iconColor} />
      {!!props.label &&
        <Text style={{paddingBottom:2,paddingLeft:6,color:iconColor,...props.labelStyle}}>{props.label}</Text>
      }
      {!props.label && props.children &&
        <View style={props.labelStyle}>{props.children}</View>
      }
    </Pressable>
  );
});

export default Checkbox;


/*
  onMouseEnter={()=>{_setIsHover(true)}} onMouseLeave={()=>{_setIsHover(false)}}

  const [isHover, _setIsHover] = useState(false);
  let iconColor = (!!isChecked
    ? (!!isHover ? (props.checkedHoverColor || window.main.theme.colors.base) : (props.checkedColor || window.main.theme.colors.base))
    : (!!isHover ? (props.uncheckedHoverColor || window.main.theme.colors.monoDark) : (props.uncheckedColor || window.main.theme.colors.monoDark))
    );
*/

